module.exports = __webpack_public_path__ + "img/sae.88eaa5ed.jpg";